var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddAccessionModal = /** @class */ (function (_super) {
    __extends(AddAccessionModal, _super);
    function AddAccessionModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onAccessionChange = function (event, data) {
            var str = data.value;
            _this.setState({ accession: str });
        };
        _this.onAccessionVersionChange = function (event, data) {
            var str = data.value;
            _this.setState({ version: str });
        };
        _this.onTranscriptNameChange = function (event, data) {
            var str = data.value;
            _this.setState({ transcriptName: str });
        };
        _this.onAccessionLengthChange = function (event, data) {
            var str = data.value;
            _this.setState({ length: str });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/accessions", {
                transcriptAccession: _this.state.accession,
                transcriptAccessionVersion: _this.state.version,
                transcriptName: _this.state.transcriptName,
                transcriptLength: _this.state.length
            });
        };
        _this.state = {
            accession: '',
            version: (0).toString(),
            length: (0).toString()
        };
        return _this;
    }
    AddAccessionModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/accession', errors: this.props.state.errors, required: true, labelContent: 'Accession number' },
                React.createElement(Input, { onChange: this.onAccessionChange, placeholder: 'XM_123', value: this.state.accession })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/version', errors: this.props.state.errors, required: true, labelContent: 'Version number' },
                React.createElement(Input, { type: 'number', onChange: this.onAccessionVersionChange, placeholder: '1', value: this.state.version })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/transcriptName', errors: this.props.state.errors, labelContent: 'transcript variant' },
                React.createElement(Input, { onChange: this.onTranscriptNameChange, placeholder: 'transcript variant 1', value: this.state.transcriptName })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/length', errors: this.props.state.errors, required: true, labelContent: 'transcript length' },
                React.createElement(Input, { type: 'number', onChange: this.onAccessionLengthChange, placeholder: '1000', value: this.state.length })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add accession number', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddAccessionModal;
}(React.PureComponent));
export default AddAccessionModal;
//# sourceMappingURL=AddAccessionModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddAccessionModal.js
// module id = 1454
// module chunks = 0